import cx from 'classnames';
import { useState } from 'react';

import { WithStyles, withStyles } from '@core/theme/utils/with-styles';
import { FieldWithCard, FieldWithCardProps } from '@shared/components/fields/field-with-card';
import { NumberField } from '@shared/components/number-field';

import { styles } from './NumberFieldWithCard.styles';

type genericProps = Omit<FieldWithCardProps, 'field' | 'setFieldInputClass'>;
export interface NumberFieldWithCardProps extends WithStyles<typeof styles>, genericProps {
  disabled?: boolean;
  error?: boolean;
  errorText?: string;
  inputPlaceholder: string;
  inputValue?: string;
  min?: number;
  onInputChange: (value: string) => void;
  onValidityChange?: (valid: boolean) => void;
}

const NumberFieldWithCardComponent: React.FC<NumberFieldWithCardProps> = ({
  classes,
  disabled = false,
  error,
  errorText,
  inputPlaceholder,
  inputValue,
  min,
  onInputChange,
  onValidityChange,
  cardLabel,
  cardSubLabel,
  ...otherProps
}) => {
  const [fieldInputClass, setFieldInputClass] = useState<string>('');
  const fieldNoBorderRadius = cardSubLabel && cardLabel;

  return (
    <FieldWithCard
      cardSubLabel={cardSubLabel}
      cardLabel={cardLabel}
      classes={{
        root: classes.root,
        cardLabel: classes.cardLabel,
        cardSubLabel: classes.cardSubLabel,
      }}
      error={error}
      {...otherProps}
      field={
        <NumberField
          classes={{
            root: classes.field,
            input: cx(
              classes.fieldInput,
              { [classes.noBorderRadius]: fieldNoBorderRadius },
              { [fieldInputClass]: !fieldNoBorderRadius }
            ),
          }}
          disabled={disabled}
          error={error}
          errorText={errorText}
          fullWidth
          min={min}
          placeholder={inputPlaceholder}
          value={inputValue}
          variant="outlined"
          onChange={onInputChange}
          onValidityChange={onValidityChange}
        />
      }
      setFieldInputClass={setFieldInputClass}
    />
  );
};

export const NumberFieldWithCard = withStyles(styles)(NumberFieldWithCardComponent);
